document.querySelectorAll('.navbar-toggler').forEach(toggler => {
    toggler.addEventListener('click', () => document.body.classList.toggle('st-no-scroll'));
});

function collapseTopMenu() {
    document.querySelectorAll('.navbar-collapse').forEach(collapseElement => {
        new bootstrap.Collapse(collapseElement, { toggle: false }).hide();
    });
    document.body.classList.remove('st-no-scroll');
}

document.querySelectorAll('.dropdown-item').forEach(item => {
    item.addEventListener('click', collapseTopMenu);
});